<template>
    <b-card class="py-0 w-100" body-class="d-flex bg-white flex-column no-border px-0 py-0 my-0">
        <b-card-body class="py-0">
            <hr class="my-1"/>
            <b-row class="pb-2">
                <b-col cols="auto">
                     <!-- 'Trend.Title' -> "Tendance" -->
                    <small class="px-0 font-weight-bold">{{ $t('Trend.Title') }}</small>
                </b-col>
                <!-- Checkbox pour affichage paramétrage de la période de tendance / période de référence -->
                <b-col class="px-0">
                    <b-form-checkbox :variant="Variant" switch v-model="useTrend" @change="updateTrendPeriod" />
                </b-col>
            </b-row>
            <b-row v-if="useTrend" class="w-100 m-1">
                <!-- TENDANCE DE TYPE TREND -->
                <b-col v-if="HasTrendType" class="p-0">
                    <b-col class="px-0">
                        <b-button-group class="d-flex btn-gray-light rounded-pill border border-gray">
                            <!-- 'Trend.Types.ConsecutivePeriod' -> "Même période consécutive" -->
                            <b-button v-if="HasPreviousTrend" @click="selectedTrend = trendPeriodEnum.Previous" :pressed="selectedTrend === trendPeriodEnum.Previous" size="sm" class="flex-grow-1" variant="outline-gray-dark text-black">
                                {{ $t('Trend.Types.ConsecutivePeriod') }}
                            </b-button> 
                            <!-- 'Trend.Types.LastYear' -> "Année -1" -->
                            <b-button v-if="HasLastYearTrend" @click="selectedTrend = trendPeriodEnum.LastYear" :pressed="selectedTrend === trendPeriodEnum.LastYear" size="sm" class="flex-grow-1" variant="outline-gray-dark text-black">
                                {{ $t('Trend.Types.LastYear') }}
                            </b-button>
                            <!-- 'Trend.Types.ReferenceYear' -> "Année de référence" -->
                            <b-button v-if="HasRefYearTrend" @click="selectedTrend = trendPeriodEnum.RefYear" :pressed="selectedTrend === trendPeriodEnum.RefYear" size="sm" class="flex-grow-1" variant="outline-gray-dark text-black">
                                {{ $t('Trend.Types.ReferenceYear') }}
                            </b-button>
                        </b-button-group>
                    </b-col>
                    <!-- Saisie de l'année de référence  -->
                    <b-col v-if="selectedTrend == trendPeriodEnum.RefYear" class="d-flex align-items-center justify-content-center pt-2">
                        <b-col cols="2">
                             <!-- 'Trend.Reference.Year' -> "Année" -->
                            <label :for="$id('trendRefYear')" class="m-0">{{ $t('Trend.Reference.Year') }}</label>
                        </b-col>
                        <b-col cols="10">
                            <b-form-select id="RefYearInput"
                                :options="availableYears"
                                value-field="Id"
                                text-field="Label"
                                size="sm"
                                plain
                                v-model="TrendRefYear"
                                class="w-100"/>
                            <!-- 'Trend.Reference.InvalidYear' -> "Année de référence invalide" -->
                            <b-form-invalid-feedback :state="Number(TrendRefYear) <= thisYear">
                                {{ $t('Trend.Reference.InvalidYear') }}
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-col>
                </b-col>
                <!-- TENDANCE DE TYPE RANGE -->
                <b-col v-if="HasReferencePeriod" class="d-flex p-0">
                    <b-col cols="2" class="p-0 d-flex align-items-center justify-content-center">
                        <label class="m-0">{{ PeriodTypes.find(x => x.Id == period.SelectedPeriod)?.Label }}</label>
                    </b-col>
                    <!-- Saisie de la période de référence -->                    
                    <!-- Année -->
                    <b-col v-if="period.SelectedPeriod == 'Year'" cols="10"> 
                        <b-form-select id="start"
                            :options="availableYears"
                            value-field="Id"
                            text-field="Label"
                            size="sm"
                            plain
                            v-model="RefYear"
                            class="w-100"
                            :state="RefValid"/>
                    </b-col>
                    <!-- Mois -->
                    <b-col v-if="period.SelectedPeriod == 'Month'" cols="10" class="d-flex">
                        <b-col>
                            <b-form-select :options="availableMonths"
                                value-field="Id"
                                text-field="Label"
                                size="sm"
                                plain
                                v-model="RefMonth"
                                class="w-100"
                                :state="RefValid"/>
                        </b-col>
                        <b-col class="pl-1">
                            <b-form-select :options="availableYears"
                                value-field="Id"
                                text-field="Label"
                                size="sm"
                                plain
                                v-model="RefYear"
                                class="w-100"
                                :state="RefValid"/>
                        </b-col>
                    </b-col>
                    <!-- Semaine -->
                    <b-col v-if="period.SelectedPeriod == 'Week'" cols="10" class="d-flex">
                        <b-col>
                            <b-form-select size="sm" plain v-model="RefWeek" :state="RefValid">
                                <b-form-select-option v-for="n in getWeekNumber(Number(RefYear))" :key="n" :value="n">{{ $t('ShortWeek') }}{{ n }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col class="pl-1">
                            <b-form-select :options="availableYears"
                                value-field="Id"
                                text-field="Label"
                                size="sm"
                                plain
                                v-model="RefYear"
                                class="w-100"
                                :state="RefValid" />
                        </b-col>
                    </b-col>
                    <!-- Jour -->
                    <b-col v-if="period.SelectedPeriod == 'Day'" cols="10">
                        <b-col>
                            <b-form-datepicker value-as-date size="sm" :max="new Date()" v-model="RefDay" hide-header v-bind="getDateLabels()" :date-format-options="{day:'2-digit', month: '2-digit', year: 'numeric'}" :state="RefValid" />
                        </b-col>
                    </b-col>
                    <!-- Message d'invalidité du formulaire -->
                </b-col>
                <!-- Période de référence invalide -->
                <b-form-invalid-feedback v-if="period && period.SelectedMode === modeEnum.Simple" :state="RefValid" class="text-center">
                    {{ $t('ReferenceAlreadyExists') }}
                </b-form-invalid-feedback>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script lang="ts">
    import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';
    import Dictionary from '@/types/Dictionary';
    import Trend from '@/types/Config/Trend';
    import TrendPeriodEnum from '@/enums/TrendPeriodEnum'; 
    import { Period } from './MultiPeriod.vue';
    import Range from '@/types/Config/Range';
    import moment from 'moment';
    import ModeEnum from '@/enums/ModeEnum';
    /** Traductions */
    import locales from './locales/TrendPeriod.json'

    /** Paramétrage d'une période de tendance */
    @Component({
        i18n: { messages: locales }
    })
    export default class TrendPeriod extends Vue {

        //# region 
        /** Variable pour utilisation de l'enum dans la section template */
		private trendPeriodEnum = TrendPeriodEnum;

        /** Récupération de la configuration */
        @PropSync('Configs', { default : () => {}})
        public configs !: Dictionary<any>; 

        /** Objet représentant les périodes sélectionnées pour les multi-périodes */
        @PropSync('Period', { default : () => {}})
        public period!: Period;

        /** Permet d'indiquer si la tendance est utilisé ou non */
        @PropSync('UseTrend', { default: () => false})
        public useTrend : boolean;
        
        /** Années disponibles */
        @PropSync('AvailableYears', { default: () => []})
        public availableYears : {Id: number, Label: string}[];

        /** Mois disponibles */
        @PropSync('AvailableMonths', { default: () => []})
        public availableMonths : {Id: number, Label: string}[];

        /** Année de référence */
        @Prop()
        public RefYear !: string; 

        /** Mois de référence */
        @Prop()
        public RefMonth !: string;

        /** Semaine de référence */
        @Prop()
        public RefWeek !: string;

        /** Jour de référence */
        @Prop()
        public RefDay !: string;

        /** Validation référence */
        @Prop()
        public RefValid !: string;

        /** Variant de couleur à appliquer sur le composant */
        @Prop({ default: () => "secondary"})
        public Variant !: string;

        /** Boolean pour l'affichage du bouton de période consécutive */
        @Prop({ default: () => false})
        public HasPreviousTrend !: boolean;

        /** Boolean pour l'affichage du bouton de année - 1*/ 
        @Prop({ default: () => false})
        public HasLastYearTrend !: boolean;

        /** Boolean pour l'affichage du bouton d'année de référence */
        @Prop({ default: () => false})
        public HasRefYearTrend !: boolean;

        /** Spécificité benchmarking @Todo Voir avec S.LAVINA si vraiment utile ??? */
        @Prop({ default: () => false})
        public HasLastYear !: boolean;

        /** Pour l'affichage de l'input pour la sélection d'une année de référence */
        @Prop({ default: () => false})
        public HasRefPeriod !: boolean;

        /** Boolean pour l'affichage de l'ensemble des tendance de Type Range */
        @Prop({ default: () => false})
        public HasReferencePeriod!: boolean;

        /** Boolean pour l'affichage de l'ensemble des tendance de Type Trend */
        @Prop({ default: () => false})
        public HasTrendType!: boolean;

        /** Liste des périodes  */
        @Prop({ default: () => []})
        public PeriodTypes!: { Id: string, Label: string }[];

        /** Année de référence pour les tendances simple période */
        public TrendRefYear: string = ""; 

        /** Permet l'utilisation de l'enum dans template
        ** Enumeration pour le mode de période (Simple ou Avancé)
        **/
        private modeEnum = ModeEnum;
         
        /** Periode de tendance */
        private trendPeriod : Trend = ({} as any);

        /** Représente l'information de l'année en cours */
		private thisYear: number = moment().year();

        /** Représente le type de période de tendance sélectionné */
        private selectedTrend: TrendPeriodEnum = TrendPeriodEnum.Previous;

        /** Liste des variables traduites pour les buttons dans le b-form-datepicker */
        protected getDateLabels() {
            console.debug("PeriodConfig - getDateLabels()");

            let dateLabels = {
                labelPrevYear: 'Année Précédente',
                labelPrevMonth: 'Mois Précédent',
                labelCurrentMonth: 'Mois Actuel',
                labelNextMonth: 'Mois Suivant',
                labelNextYear: 'Année Suivante',
                labelHelp: ''
            }

            return dateLabels;
        }

        /**
         * Donne le nombre de semaines selon une année donnée
         * @param year année 
         * @returns Nombre de semaine de l'annee
         */
        protected getWeekNumber(year: number): number {
            return moment().year(year).weeksInYear();
        }

        
        /** Ajoute la période de référence à l'objet period */
        @Watch('useTrend')
        @Watch('period.SelectedPeriod')
        @Watch('selectedTrend')
        @Watch('RefYear')
        @Watch('TrendRefYear')
        @Watch('RefMonth')
        @Watch('RefWeek')
        @Watch('RefDay')
        protected updateTrendPeriod(){
            
            /** Miseà jour de la période de Type RANGE */
            if(this.HasReferencePeriod){
                /** Bool utilisation période de référence */
                if(this.useTrend){
                    let range: Range;
                    let start: string;
                    let end: string;
                    
                    switch (this.period.SelectedPeriod) {
                        case "Year":
                            start = this.RefYear;
                            end = start;
                        break;
                        case "Month":
                            start = this.RefMonth+"|"+this.RefYear;
                            end = start;
                        break;
                        case "Week":
                            start = (Number(this.RefWeek) < 10 ? "0" + this.RefWeek : this.RefWeek)+"|"+this.RefYear;
                            end = start;
                        break;
                        case "Day":
                            start = moment(this.RefDay).format("DD/MM/YYYY");
                            end = start;
                        break;
                    }

                    console.debug("TrendPeriod - updateTrendPeriod - selectedPeriod : %O - start : %O - end : %O", this.period.SelectedPeriod, start, end);

                    range = { Mode: "Simple", Type: "Range", Periodicity: this.period.SelectedPeriod, Compare: false, Start: start, End: end }

                    this.period.RefPeriod = range;
                } 
                /** Si suppression de la période de référence */
                else 
                {
                    let index = this.configs["Periods"].findIndex(x => String(x.Type).includes("Range"));

                    if(index != -1)
                        this.configs["Periods"].splice(index,1);

                    this.period.RefPeriod = null;

                    console.debug("TrendPeriod - updateTrendPeriod - this.configs['Periods'] : %O", this.configs["Periods"]);
                }
            }

            /** Mise à jour de la période si Period type TREND */
            if(this.HasTrendType){
                /** Bool utilisation période de référence */
                if(this.useTrend){
                    let index: number = this.configs["Periods"].findIndex(x => String(x.Type).includes("Trend"));
                    this.trendPeriod = { Mode: 'Simple', Type: "Trend", Periodicity: 'None', Compare: false, Year: this.TrendRefYear.toString(), TrendType: this.selectedTrend, Total : false }
                    if(index != -1)
                        this.configs["Periods"][index] = this.trendPeriod;
                    else 
                        this.configs["Periods"].push(this.trendPeriod);

                    console.debug("TrendPeriod - updateTrendPeriod - this.configs['Periods'] : %O", this.configs["Periods"]);

                } 
                /** Si suppression de la période de référence */
                else 
                {
                    let index = this.configs["Periods"].findIndex(x => String(x.Type).includes("Trend"));

                    if(index != -1)
                        this.configs["Periods"].splice(index,1);

                    console.debug("TrendPeriod - updateTrendPeriod - this.configs['Periods'] : %O", this.configs["Periods"]);
                }
            }
        }

        /** Chargement de la tendance paramétré */
        private loadTrendPeriod(){
            /** Période de référence de type TREND */
            if(this.HasReferencePeriod){
                let refPeriod = this.configs["Periods"].find(x => String(x.Type).includes("Range"));

                // Condition rajoutée car à la première ouverture widget/analyses, 
                // la tendance n'est pas activé et par conséquent 'refPeriod' n'est pas renseignée.
                if(refPeriod){
                    switch(refPeriod.Periodicity){
                        case "Year":
                            this.RefYear = refPeriod.Start;
                            break;
                        case "Month":
                            this.RefMonth = refPeriod.Start.split('|')[0];
                            this.RefYear = refPeriod.Start.split('|')[1];
                            break;
                        case "Week":
                            this.RefWeek = refPeriod.Start.split('|')[0];
                            this.RefYear = refPeriod.Start.split('|')[1];
                            break;
                        case "Day":
                            this.RefDay = refPeriod.Start;
                            break;
                    }

                    this.useTrend = true;
                }
            }

            /** Période de référence de type RANGE */
            if(this.HasTrendType){
                let trendPeriod = this.configs["Periods"].find(x => String(x.Type).includes("Trend"));

                this.selectedTrend = TrendPeriodEnum.Previous;
                this.TrendRefYear = moment().year().toString();

                if (trendPeriod) {
                    this.useTrend = true;
                    this.selectedTrend = trendPeriod.TrendType;
                    this.TrendRefYear = trendPeriod.Year;
                }
            }
        }

        /** Création du composant */
        created(){
            this.loadTrendPeriod();
        }
    }

</script>
<style scoped>

</style>

